import { Input as ChakraInput } from '@chakra-ui/input';

export const Input = ChakraInput;
